

<template>
  <div class="app">
    <!-- loader that only shows when pdf is loading -->
    <div class="loader hidden flex justify-center items-center">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <!-- Screen that shows efore test hast started -->
    <div v-if="!testStarted">
      <div class="container mx-auto pt-10 pb-10 container__mobile">
        <div class="flex">
          <div class="w-12/12">
            <h1 class="font-black text-green mb-6 heading">
              <strong class="text-white">Wertetest</strong> Wertepole
            </h1>
            <p class="leading-snug">
              Welche Werte sind in Dir besonders stark ausgeprägt und zu welchem
              inneren Motivationsfeld gehören sie? Überwiegen bei Dir oder in
              Deinem Unternehmen Stimulanz, Dominanz oder Balance? Oder bist Du
              doch eher Abenteurer, Disziplinierter oder der Genießer?
            </p>
          </div>
        </div>
        <img src="./assets/start.svg" alt="" class="mt-10 mr-auto ml-auto" />
        <div class="flex justify-center">
          <button
            class="px-6 py-3 rounded uppercase next__step mt-5"
            @click="startTest()"
          >
            start
          </button>
        </div>
      </div>
    </div>
    <!-- actual test  -->
    <div v-if="!testDone && testStarted">
      <div class="container mx-auto pt-10 pb-10">
        <div class="flex">
          <div class="w-12/12">
            <h1 class="font-black text-green mb-6 heading">
              <strong class="text-white">Wertetest</strong> Wertepole
            </h1>
            <!-- might become conditional soon -->
            <p class="leading-snug">
              Welche Werte sind in Dir besonders stark ausgeprägt und zu welchem
              inneren Motivationsfeld gehören sie. Überwiegen bei Dir oder in
              Deinem Unternehmen Stimulanz, Dominanz oder Balance? Oder bist Du
              doch eher Abenteurer, Disziplinierter oder der Genießer?
            </p>
          </div>
        </div>
      </div>

      <div class="container mx-auto py-20">
        <div class="flex items-center">
          <div class="w-3/12 lg:block hidden">
            <!-- loads text and image paths from the questions array -->
            <!--  image are scaled according to value might remove later -->
            <div class="text-center">
              <img
                :src="[questions[currentQuestion][2]]"
                alt="cowboy"
                class="step__picture"
                :class="['scale--' + (21 + selectedValue)]"
              />
            </div>
            <div class="text-center step__text">
              {{ questions[currentQuestion][0] }}
            </div>
          </div>
          <div class="lg:w-6/12 w-full">
            <div class="flex justify-between items-center">
              <div class="flex-1">
                <ul class="steps">
                  <!-- logic is for bumb on slider -->
                  <li
                    class="steps__item"
                    :class="[
                      'steps__item--' + (index - steps - 1) * -1,
                      selectedValue <= index - steps - 1
                        ? 'steps__item--active'
                        : '',
                      selectedValue == index - steps - 1
                        ? 'steps__item--current'
                        : '',
                      selectedValue === index - steps - 1 + 1 ||
                      selectedValue === index - steps - 1 - 1
                        ? 'steps__item--current--1'
                        : '',
                      selectedValue === index - steps - 1 + 2 ||
                      selectedValue === index - steps - 1 - 2
                        ? 'steps__item--current--2'
                        : '',
                      selectedValue === index - steps - 1 + 3 ||
                      selectedValue === index - steps - 1 - 3
                        ? 'steps__item--current--3'
                        : '',
                      selectedValue === index - steps - 1 + 4 ||
                      selectedValue === index - steps - 1 - 4
                        ? 'steps__item--current--4'
                        : '',
                    ]"
                    v-for="index in steps"
                    :key="index"
                    @click="setValue(index - steps - 1)"
                  ></li>
                  <li
                    class="steps__item"
                    :class="[
                      'steps__item--' + index,
                      index <= selectedValue ? 'steps__item--active' : '',
                      selectedValue == index ? 'steps__item--current' : '',
                      selectedValue === index + 1 || selectedValue === index - 1
                        ? 'steps__item--current--1'
                        : '',
                      selectedValue === index + 2 || selectedValue === index - 2
                        ? 'steps__item--current--2'
                        : '',
                      selectedValue === index + 3 || selectedValue === index - 3
                        ? 'steps__item--current--3'
                        : '',
                      selectedValue === index + 4 || selectedValue === index - 4
                        ? 'steps__item--current--4'
                        : '',
                    ]"
                    v-for="index in steps"
                    :key="index"
                    @click="setValue(index)"
                  ></li>
                </ul>
                <Slider
                  v-model="selectedValue"
                  :min="steps * -1"
                  :max="steps"
                />
              </div>
            </div>
          </div>

          <div class="w-3/12 lg:block hidden">
            <div class="text-center">
              <img
                :src="[questions[currentQuestion][3]]"
                alt="cowboy"
                class="step__picture"
                :class="['scale--' + (21 - selectedValue)]"
              />
            </div>
            <div class="text-center step__text">
              {{ questions[currentQuestion][1] }}
            </div>
          </div>
        </div>
        <div class="lg:hidden block div flex justify-between">
          <div class="text-center step__text">
            {{ questions[currentQuestion][0] }}
          </div>
          <div class="text-center step__text">
            {{ questions[currentQuestion][1] }}
          </div>
        </div>
        <div class="flex justify-between">
          <!-- same Images again because of bad responsive design sorry abbout that -->
          <div class="lg:hidden block flex justify-center mt-6">
            <img
              :src="[questions[currentQuestion][2]]"
              alt="cowboy"
              class="step__picture--small"
              :class="['scale--' + (21 + selectedValue)]"
            />
          </div>
          <div class="lg:hidden block flex justify-center mt-6">
            <img
              :src="[questions[currentQuestion][3]]"
              alt="cowboy"
              class="step__picture--small"
              :class="['scale--' + (21 - selectedValue)]"
            />
          </div>
        </div>
      </div>

      <div class="container mx-auto">
        <div
          class="
            w-full
            h-5
            relative
            rounded-lg
            overflow-hidden
            bg-bluegray-light
          "
        >
          <div
            class="
              h-full
              absolute
              top-0
              left-0
              bg-green
              transition-all
              ease-in-out
            "
            :style="{ width: progress + '%' }"
          ></div>
        </div>
      </div>

      <div class="container mx-auto py-6">
        <div class="flex justify-between">
          <div class="flex-shrink">
            <button
              class="px-6 py-3 rounded uppercase back__step"
              v-if="currentQuestion !== 0"
              @click="prevQuestion()"
            >
              zurück
            </button>
          </div>
          <div class="my-2" style="text-align: center">
            Wertepaar {{ currentQuestion + 1 }} von {{ questions.length }}
          </div>
          <div class="flex-shrink">
            <button
              class="px-6 py-3 rounded uppercase"
              :class="[
                selectedValue === 0 ? 'next__step--disabled' : 'next__step',
              ]"
              @click="nextQuestion()"
            >
              weiter
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- This is the result -->
    <div class="container mx-auto pt-10 pb-10" v-if="testDone">
      <div class="ml-5 w-12/12" id="header">
        <h1 class="font-black text-green heading">
          <strong class="text-white">Wertetest</strong> Wertepole – Werte
          intuitiv erfassen
        </h1>

        <div class="flex">
          <!-- Texts might be dynamic soon -->
          <p class="leading-snug w-12/12">
            <span class="leading-peace">{{ max.name }}</span>
            <br />
            <br />
            {{ max.text }}
          </p>
        </div>
      </div>
      <div
        class="result__chart__container result__chart__container__mobile"
        ref="chart"
        id="chart"
      >
        <div class="result__chart mx-auto">
          <!-- are positioned abbsoult around the cahrt -->
          <p class="chart__legend chart__legend__mobile chart__legend--3">
            WACHSTUM
          </p>
          <p class="chart__legend chart__legend__mobile chart__legend--4">
            ABWECHSLUNG / VIELFALT
          </p>
          <p class="chart__legend chart__legend__mobile chart__legend--5">
            BEITRAG LEISTEN
          </p>
          <p class="chart__legend chart__legend__mobile chart__legend--6">
            ZUGEHÖRIGKEIT
          </p>
          <p class="chart__legend chart__legend__mobile chart__legend--2">
            BEDEUTUNG
          </p>
          <p class="chart__legend chart__legend__mobile chart__legend--1">
            SICHERHEIT / KOMFORT
          </p>
          <ul class="result__chart__pie">
            <li
              v-for="layer in 40"
              :key="layer"
              class="result__chart__pie__layer"
            >
              <ul
                class="pie"
                :class="['pie--' + layer, layer % 2 === 0 ? 'noslices' : '']"
              >
                <li class="slice" v-for="index in 48" :key="index">
                  <!-- Logic for coloring -->
                  <div
                    class="slice-contents"
                    :class="[
                      index > 0 && index < 9 ? 'slice-contents--green' : '',
                      index > 8 && index < 17 ? 'slice-contents--cyan' : '',
                      index > 16 && index < 25 ? 'slice-contents--orange' : '',
                      index > 24 && index < 33 ? 'slice-contents--green' : '',
                      index > 32 && index < 41 ? 'slice-contents--cyan' : '',
                      index > 40 && index < 49 ? 'slice-contents--orange' : '',

                      (result[index - 1] >= 20 - layer / 2 && index < 25) ||
                      (result[index - 24 - 1] <= -20 + layer / 2 && index > 24)
                        ? ''
                        : 'slice-contents--grey',
                    ]"
                    :style="[
                      layer === 40
                        ? {
                            backgroundImage: 'url(./assets/chart.svg)',
                            backgroundSize: '100%',
                            backgroundPosition: 'center',
                          }
                        : '',
                    ]"
                  ></div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div class="flex justify-around">
        <button
          class="px-6 py-3 rounded uppercase again__button"
          @click="goBack()"
        >
          NOCHMAL
        </button>
        <button
          class="px-6 py-3 rounded uppercase pdf__button"
          @click="generatePDF()"
        >
          PDF
        </button>
      </div>
      <!-- This exists only for the pdf -->
      <div class="flex justify-center ml-5 mt-5 hidden" id="detailedResult">
        <ul class="mt-20">
          <li v-for="question in questions" :key="question">
            <div class="detailed__result-li flex">
              <p class="detailed__result__align-right">{{ question[0] }}</p>
              <ul class="flex detailed__result__vals">
                <li v-for="val in 20" :key="val">
                  <div
                    class="detailed__result__val"
                    :class="[
                      questions.indexOf(question) + 1 > 0 &&
                      questions.indexOf(question) + 1 < 9
                        ? 'slice-contents--green'
                        : '',
                      questions.indexOf(question) + 1 > 8 &&
                      questions.indexOf(question) + 1 < 17
                        ? 'slice-contents--cyan'
                        : '',
                      questions.indexOf(question) + 1 > 16 &&
                      questions.indexOf(question) + 1 < 25
                        ? 'slice-contents--orange'
                        : '',
                      val < 11 && result[questions.indexOf(question)] > 0
                        ? 'slice-contents--grey'
                        : val - 10 > result[questions.indexOf(question)] / 2 ||
                          val > 10
                        ? ''
                        : 'slice-contents--grey',
                      ,
                      val > 10 && result[questions.indexOf(question)] < 0
                        ? 'slice-contents--grey'
                        : val - 10 <
                            result[questions.indexOf(question)] / 2 + 1 ||
                          val < 11
                        ? ''
                        : 'slice-contents--grey',
                    ]"
                  ></div>
                </li>
              </ul>
              <p class="detailed__result__align-left">{{ question[1] }}</p>
            </div>
          </li>
        </ul>
      </div>
      <div id="explainText" class="flex ml-5 mr-5 justify-center mt-20 hidden">
        <div class="w-12/12 mt-10">
          <p class="leading-snug font-black">
            Wie diese Auswertung zu lesen ist
          </p>

          <div class="flex">
            <p class="w-12/12">
              Das Wichtigste zuerst: Es gibt keine richtigen oder falschen
              Werte. Dieser Selbsttest zeigt eine deutliche Tendenz der Werte,
              die Dir wichtig sind, die Du gerade lebst und die Dich
              repräsentieren. Sie offenbaren Stärken und Potentiale und
              skizzieren den Startpunkt für mögliche Entwicklungen. Sie spiegeln
              Deinen aktuellen Status quo wider.
              <br />
              <br />

              Zusätzlich zu Deinen persönlichen Werten kannst Du den Test auch
              aus der Perspektive Deines Teams oder Deiner Organisation
              absolvieren. Dann spiegelt das Ergebnis Deine persönliche
              Einschätzung der Werte Deines Umfelds wider. Spannend ist auch,
              wenn Ihr den Test als Team macht. Jede:r für sich. Ohne
              Absprachen. Die anschließende Diskussion über Unterschiede oder
              Ähnlichkeiten werden Euch als Team weiterbringen.

              <br />
              <br />
              Vermutlich hast Du Aussagen getroffen, die sich in
              unterschiedlichen Wertefeldern widerspiegeln. In der Regel gibt es
              Häufungen in mehr als einem Bereich. Dort, wo Du einen deutlichen
              Ausschlag hast, gibt es eine eindeutige Werte-Tendenz.

              <br />
              <br />
              In den Bereichen mit einem schwachen Ausschlag kann es sein, dass
              Du Dir bei einigen Punkten nicht sicher und zu vorsichtig warst.
              Vielleicht schaust Du Dir nochmal die Punkte an, bei denen es Dir
              schwergefallen ist, Dich festzulegen. Frage Dich vielleicht auch,
              warum Dir an dieser Stelle eine Festlegung so schwer fällt. Je
              eindeutiger Deine Aussagen sind, um so näher kommst du deinen
              Kernwerten.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script >
import Slider from "@vueform/slider";
import html2pdf from "html2pdf.js";

export default {
  name: "App",
  components: {
    Slider,
  },
  data() {
    // the number in the end is used to determine order after shuffling of the questions
    // might add texts here as well
    return {
      questions: [
        [
          "außergewöhnlich",
          "normal",
          "/illus/SC_21-1_Außergewohnlich.svg",
          "/illus/SC_21-2_Normal.svg",
          1,
        ],
        [
          "schnell",
          "gründlich",
          "/illus/SC_22-1_Schnell.svg",
          "/illus/SC_22-2_Grundlich.svg",
          2,
        ],
        [
          "experimentell",
          "routiniert",
          "/illus/SC_23-1_Experimentell.svg",
          "/illus/SC_23-2_Routiniert.svg",
          3,
        ],
        [
          "impulsiv",
          "überlegt",
          "/illus/SC_24-1_Impulsiv.svg",
          "/illus/SC_24-2_Uberlegt.svg",
          4,
        ],
        [
          "spontan",
          "geplant",
          "/illus/SC_1-1_Spontan.svg",
          "/illus/SC_1-2_Geplant.svg",
          5,
        ],
        [
          "mutig",
          "zurückhaltend",
          "/illus/SC_2-1_Mutig.svg",
          "/illus/SC_2-2_Zuruckhaltend.svg",
          6,
        ],
        [
          "laut",
          "leise",
          "/illus/SC_3-1_Laut.svg",
          "/illus/SC_3-2_Leise.svg",
          7,
        ],
        [
          "dynamisch",
          "statisch",
          "/illus/SC_4-1_Dynamisch.svg",
          "/illus/SC_4-2_Statisch.svg",
          8,
        ],
        [
          "hart",
          "kooperativ",
          "/illus/SC_5-1_Hart.svg",
          "/illus/SC_5-2_Kooperativ.svg",
          9,
        ],
        [
          "fordernd",
          "gebend",
          "/illus/SC_6-1_Fordernd.svg",
          "/illus/SC_6-2_Gebend.svg",
          10,
        ],
        [
          "solitär",
          "kollektiv",
          "/illus/SC_7-1_Solitar.svg",
          "/illus/SC_7-2_Kollektiv.svg",
          11,
        ],
        [
          "elitär",
          "empathisch",
          "/illus/SC_8-1_Elitar.svg",
          "/illus/SC_8-2_Emphatisch.svg",
          12,
        ],

        //Dominanz - Fantasie / Genuss

        [
          "durchsetzungsstark",
          "angepasst",
          "/illus/SC_9-1_Durchsetzungsstark.svg",
          "/illus/SC_9-2_Angepasst.svg",
          13,
        ],
        [
          "steil",
          "flach",
          "/illus/SC_10-1_Steil.svg",
          "/illus/SC_10-2_Flach.svg",
          14,
        ],
        [
          "herausfordernd",
          "gemütlich",
          "/illus/SC_11-1_Herausfordernd.svg",
          "/illus/SC_11-2_Gemutlich.svg",
          15,
        ],
        [
          "diszipliniert",
          "locker",
          "/illus/SC_12-1_Diszipliniert.svg",
          "/illus/SC_12-2_Locker.svg",
          16,
        ],

        //Disziplin - Kontrolle / Stimulanz
        [
          "strukturiert",
          "fantasievoll",
          "/illus/SC_13-1_Strukturiert.svg",
          "/illus/SC_13-2_Fantasievoll.svg",
          17,
        ],
        [
          "nüchtern",
          "leidenschaftlich",
          "/illus/SC_14-1_Nuchtern.svg",
          "/illus/SC_14-2_Leidenschaftlich.svg",
          18,
        ],
        [
          "spezialisiert",
          "vielseitig",
          "/illus/SC_15-1_Spezialisiert.svg",
          "/illus/SC_15-2_Vielseitig.svg",
          19,
        ],
        [
          "kontrolliert",
          "intuitiv",
          "/illus/SC_16-1_Kontrolliert.svg",
          "/illus/SC_16-2_Intuitiv.svg",
          20,
        ],
        [
          "geizig",
          "großzügig",
          "/illus/SC_17-1_Geizig.svg",
          "/illus/SC_17-2_Großzugig.svg",
          21,
        ],
        [
          "aufopferungsvoll",
          "hedonistisch",
          "/illus/SC_18-1_Aufopferungsvoll.svg",
          "/illus/SC_18-2_Hedonistisch.svg",
          22,
        ],
        [
          "traditionell",
          "exotisch",
          "/illus/SC_19-1_Traditionell.svg",
          "/illus/SC_19-2_Exotisch.svg",
          23,
        ],
        [
          "pflichtbewusst",
          "neugierig",
          "/illus/SC_20-1_Pflichtbewusst.svg",
          "/illus/SC_20-2_Neugierig.svg",
          24,
        ],
      ],
      max: {
        name: "y0",
        text: "hs",
      },
      steps: 20,
      selectedValue: 0,
      currentQuestion: 0,
      progress: 0,
      result: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      resultChart: [],
      testDone: false,
      testStarted: false,
    };
  },
  created() {
    for (var i = 0; i < this.questions.length * 2; i++) {
      this.resultChart[i] = 0;
    }
    // this.questions = this.shuffleArray(this.questions);
  },
  watch: {
    currentQuestion(newValue) {
      this.progress = (newValue / this.questions.length) * 100;

      if (newValue === this.questions.length) {
        console.log(this.result);
        this.max = this.getGreatestOne();
        this.testDone = true;
      }
    },
  },
  computed: {
    classObject: function () {
      return {
        active: this.isActive && !this.error,
        "text-danger": this.error && this.error.type === "fatal",
      };
    },
  },
  methods: {
    selectOption: function (value) {
      let alpha = this.currentQuestion,
        beta = this.questions.length + this.currentQuestion;

      if (value <= 3) {
        this.resultChart[alpha] = value;
      } else {
        this.resultChart[beta] = value - 3;
      }

      this.currentQuestion++;
    },
    // shuffleArray: function (array) {
    //   //shuffles array
    //   for (let i = array.length - 1; i > 0; i--) {
    //     const j = Math.floor(Math.random() * (i + 1));
    //     const temp = array[i];
    //     array[i] = array[j];
    //     array[j] = temp;
    //   }
    //   return array;
    // },
    startTest: function () {
      this.testStarted = true;
    },
    setValue: function (index) {
      this.selectedValue = index;
    },
    goBack: function () {
      this.selectedValue = 0;
      this.currentQuestion = 0;
      this.progress = 0;
      this.result = [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ];
      this.resultChart = [];
      this.testDone = false;
    },
    getGreatestOne: function () {
      //used for the pdf
      //title is the title and text is the text in the pdf
      let valueSections = [
        {
          name: "Sicherheit und Komfort",
          count: 0,
          image: "/Sicherheit.png",
          text: "Dein stärkster Wertebereich ist Sicherheit und Komfort. Menschen, Teams oder Organisationen, die im Bereich Sicherheit/Komfort unterwegs sind, gehören zu jenen, die sich ihrer Wurzeln und Traditionen bewusst sind. Ihnen ist es wichtig, einen sichereren und verlässlichen Raum zu schaffen, in dem sie sich wohlfühlen. Sie sind glaubwürdig, wirken vertraut und gehen mit Herausforderungen entspannt um. Wie in einer Familie kennen  – und verzeihen – sie die großen und kleinen Fehler der anderen und sind von der Idee eines friedlichen Miteinanders geleitet. Sie bewahren Werte und tragen Sorge, dass bisher Erreichtes auch künftigen Generationen von Nutzen ist. Hierbei folgen sie dem Credo, dass nur jene eine sichere Zukunft gestalten können, die die Vergangenheit kennen. In diesem Sinne mögen sie Kontinuität und Stabilität und sorgen dafür, dass Errungenschaften auch künftigen Generationen von Nutzen sein werden. ",
        },
        {
          name: "Abwechslung und Vielfalt",
          image: "/Abwechslung.png",
          count: 0,
          text: "Dein stärkster Wertebereich ist Abwechslung und Vielfalt. Menschen, Teams oder Organisationen, die im Bereich Abwechslung und Vielfalt unterwegs sind, gehören zu denen, die Dinge in Bewegung bringen. Sie sind neugierig auf alles Neue und haben den Mut, ungekannte Wege zu gehen. Probleme oder Herausforderungen werden nicht ausgesessen. Schon bei den ersten Anzeichen für Schwierigkeiten werden Lösungen gesucht – und meist auch gefunden. Sie sind experimentell, probieren sich aus und haben keine Angst zu scheitern. Sie sehen Scheitern nicht als etwas Negatives, sondern vielmehr als einen von vielen möglichen Wegen zur Erkenntnis. Deshalb gibt es immer wieder Startpunkte und Neuausrichtungen. Auch wenn es dabei manchmal chaotisch zugeht, die Richtung ist klar: Jeden Tag eine bessere Zukunft, eine bessere Zusammenarbeit oder ein besseres Produkt. ",
        },
        {
          name: "Zugehörigkeit",
          count: 0,
          image: "/Zugehorigkeit.png",
          text: "Dein stärkster Wertebereich ist Zugehörigkeit. Menschen, Teams oder Organisationen, die sich im Bereich Zugehörigkeit bewegen, zeichnen sich durch eine große Offenheit und Kooperationsbereitschaft aus. Sie begreifen Unterschiedlichkeiten als wertvolle Ressource, die das gemeinsame Vorhaben bereichern und von denen alle profitieren können. Sie verbinden Menschen und sorgen mit Ihrer hohen Kooperationsbereitschaft für Harmonie und Fairness. Hierbei sind sie fest davon überzeugt, dass Humor und Spaß nicht allein Fähigkeiten sind, die ein geselliges Miteinander begünstigen, sondern ein zweckdienliches, mentales Werkzeug, mit dem sich jede Herausforderung leichter, flexibler und mit mehr Freude lösen lässt. Wo sie sind, herrscht Nähe, gute Laune und das Arbeiten macht Spaß. ",
        },
        {
          name: "Bedeutung",
          image: "/Bedeutung.png",
          count: 0,
          text: "Dein stärkster Wertebereich ist Bedeutung. Menschen, Teams oder Organisationen, die im Bereich Bedeutung unterwegs sind, gehören zu jenen, die sich von anderen absetzen und deren Leistungen Anerkennung erhalten. Sie haben einen hohen Anspruch an Qualität, stehen für besonders herausragende Produkte und begründen nicht selten neue Standards. Sie spielen in einer eigenen Liga, sind performanceorientiert und haben Lust auf Leistung. Für andere Menschen besitzen sie eine besondere Anziehungskraft. Sie haben eine klare Vorstellung davon, wie etwas zu sein hat und arbeiten mit großer Ernsthaftigkeit daran, ihre Idee zu realisieren. Dafür ist ihnen keine Mühe zu groß und kein Weg zu weit. Ist das Ziel dann erreicht, haben sie längst ein neues Projekt im Visier – und auch hier können wir davon ausgehen, dass sie es erfolgreich umsetzen und sie dafür anerkennend bewundert werden.",
        },
        {
          name: "Wachstum",
          image: "/Wachstum.png",
          count: 0,
          text: "Dein stärkster Wertebereich ist Wachstum. Kreativität und Innovationsfreude sind für Menschen, Teams oder Organisationen, die im Bereich Wachstum unterwegs sind, die zentralen Motivatoren. Damit sie ihr volles Potenzial leben können, brauchen sie eine permanente Abwechslung in den Herausforderungen und die Gewissheit, mit jeder Aufgabe zu lernen und zu wachsen. Dieses tiefe Bedürfnis ist es, was sie beweglich und jung im Kopf hält. Sie sind neugierig auf frische Impulse, begeistern mit extravaganten Lösungen und erfinden sich immer wieder neu. Bei allem, was sie tun, geht es auch immer darum, andere zu erfreuen. Mit ihrem stetigen Wachstum und ihrer Fantasie entwickeln sie sich nicht nur stetig selbst weiter, sondern sorgen auch für Wachstum bei all jenen, die mit ihnen zu tun haben.  ",
        },
        {
          name: "Beitrag leisten",
          image: "/Beitrag.png",
          count: 0,
          text: "Dein stärkster Wertebereich ist Beitrag leisten. Für Menschen, Teams oder Organisationen, die sich im Bereich Beitrag leisten bewegen, sind feste Strukturen und klare Hierarchien ein wichtiger Bestandteil des Alltages. Das gibt ihnen einen Rahmen, in dem sie ihre Loyalität leben und Prozesse mit Pflichtgefühl, Ausdauer und Fleiß am Laufen halten. Sie sind Garanten für Ordnung, wägen Kosten und Nutzen genau miteinander ab und stellen, wenn es der Sache dient, persönliche Bedürfnisse hinten an. Es ist die spannende Kombination von Anpassungsfähigkeit und Struktur, die ihnen eine große Kraft verleiht. Sie sind das präzise Getriebe im Großen und Ganzen. Ohne sie läuft nichts. Sie wissen um diese Verantwortung, weshalb sich Unternehmen und Gesellschaften auch in stürmischen und chaotischen Zeiten auf sie verlassen können. Sie freuen sich über die Anerkennung der geleisteten Arbeit, widmen dieser Aufmerksamkeit dann aber nicht zu allzu viel Zeit, denn sie werden gebraucht – es gibt schließlich noch eine Menge zu tun.",
        },
      ];
      for (let i = 0; i <= 24; i++) {
        if (i < 8) {
          this.result[i] > 0
            ? (valueSections[0].count += this.result[i])
            : (valueSections[1].count -= this.result[i]);
        } else if (i > 7 && i < 16) {
          this.result[i] > 0
            ? (valueSections[2].count += this.result[i])
            : (valueSections[3].count -= this.result[i]);
        } else if (i > 15 && i < 24) {
          this.result[i] > 0
            ? (valueSections[4].count += this.result[i])
            : (valueSections[5].count -= this.result[i]);
        }
      }

      let max = valueSections.reduce(function (prev, current) {
        if (+current.count > +prev.count) {
          return current;
        } else {
          return prev;
        }
      });
      console.log(max);
      return max;
    },
    prevQuestion: function () {
      this.currentQuestion--;
      this.selectedValue =
        this.result[this.questions[this.currentQuestion][4] - 1];
    },

    generatePDF: async function () {
      //show loader
      let loader = document.querySelector(".loader");
      loader.classList.remove("hidden");

      let pdf = document.createElement("div");
      pdf.classList.add("pdf");

      let header = document.getElementById("header");

      header.classList.add("pdf__black-font");
      header.classList.add("pdf__header__different__text");

      let chart = document.getElementById("chart");
      chart.classList.add("pdf__white-bg");
      chart.classList.remove("result__chart__container__mobile");

      pdf.appendChild(header.cloneNode(true));
      pdf.appendChild(chart.cloneNode(true));

      chart.classList.add("result__chart__container__mobile");

      let greatestOne = this.getGreatestOne();

      let greatestSection = document.createElement("div");
      greatestSection.classList.add("flex");
      greatestSection.classList.add("pdf__black-color");
      greatestSection.classList.add("pdf__moveUp__svg");

      let greatestSection__text = document.createElement("div");
      greatestSection__text.innerHTML = `      <div style="margin-left: 20px; margin-right:30px;"><h5 class="font-black ">Bedürfnisbereich : ${greatestOne.name}</h5>
            <p style="font-size: 11px">${greatestOne.text}</p>
            </div> `;
      let greatestSection__svg = document.createElement("img");
      greatestSection__svg.setAttribute("src", greatestOne.image);
      greatestSection__svg.classList.add("pdf__svg");

      greatestSection.appendChild(greatestSection__svg);
      greatestSection.appendChild(greatestSection__text);
      pdf.appendChild(greatestSection);

      let footer = document.createElement("div");
      footer.classList.add("flex");
      footer.classList.add("justify-between");
      footer.classList.add("mb-20");
      footer.classList.add("pdf__black-color");
      footer.classList.add("pdf__moveUp__footer");

      footer.innerHTML = `<div class="ml-5" style="color: #87be2d; text-decoration: uppercase;"><h5>WERTE WIRKEN</h5>
            <p style="font-size: 12px;">STRATEGIE MARKE UND KULTUR MIT WERTEN ENTWICKELN</p>
            </div> <img style="position: relative; right: 20px; width: 170px; height: 30px;" alt="short-cuts" src="/logo.png"></img>`;

      pdf.appendChild(footer.cloneNode(true));

      header.classList.remove("pdf__header__different__text");

      chart.classList.remove("pdf__white-bg");
      header.classList.remove("pdf__black-font");
      let detailedResult = document.getElementById("detailedResult");
      detailedResult.classList.add("pdf__white-bg--detail");
      detailedResult.classList.remove("hidden");

      pdf.appendChild(detailedResult.cloneNode(true));
      detailedResult.classList.remove("pdf__white-bg--detail");
      detailedResult.classList.add("hidden");

      let explainText = document.getElementById("explainText");
      explainText.classList.remove("hidden");
      pdf.appendChild(explainText.cloneNode(true));

      explainText.classList.add("hidden");

      pdf.appendChild(footer.cloneNode(true));

      await html2pdf(pdf, {
        margin: 5,
        filename: "dein-wertetest.pdf",
        image: { type: "jpg", quality: 1 },
        html2canvas: {
          letterRendering: true,
          height: "2020",
          dpi: 1200,
          scrollY: 0,
          scale: 4,
        },
        jsPDF: { unit: "mm", format: "letter", orientation: "portrait" },
      });
      //hide loader
      loader.classList.add("hidden");
    },
    nextQuestion: function () {
      if (this.selectedValue) {
        this.result[this.questions[this.currentQuestion][4] - 1] =
          this.selectedValue;
        this.currentQuestion++;
        this.selectedValue =
          this.result[this.questions[this.currentQuestion][4] - 1];
      } else {
        let button = document.querySelector(".slider-handle");
        button.classList.add("extend");
        setTimeout(() => {
          button.classList.remove("extend");
        }, 3000);
      }
    },
  },
};
</script>

<style src="@vueform/slider/themes/default.css"></style>


<style lang="css">
body {
  overflow-x: hidden;
}
#explainText {
  color: black;
  position: relative;
  bottom: 200px;
  font-size: 11px;
  margin-left: 40px;
  margin-right: 40px;
  margin-top: 60px;
}

.heading {
  line-height: 1.2;
}
/* way too many classes could also be solved dynamically */
.pdf {
  padding: 30px 25px 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.random__class {
  bottom: 30px;
}
.pdf__moveUp__svg {
  position: relative;
  bottom: 40px;
  margin-left: 20px;
  margin-top: 40px;
}
.pdf__white-bg--detail {
  color: black;
  position: relative;
  bottom: 140px;
}
.pdf__white-bg--detail .slice-contents--grey {
  background: #70707040;
}
#detailed__result {
  position: relative;
  top: 20px;
  margin-top: -20px;
  transform: scale(0.9);
}
.pdf__moveUp__header2 {
  position: relative;
  top: 30px;
}
.pdf__moveUp__footer {
  position: relative;
  bottom: 0px;
}
.pdf__svg {
  height: 170px;
  margin-bottom: 20px;
}
.pdf__black-font h1 {
  color: #87be2d;
}
.pdf__black-color {
  color: black;
  width: 100%;
}
.pdf__black-font h1 strong {
  color: black;
}
.pdf__black-font div p {
  color: black;
  margin-right: 20px;
}
.pdf__white-bg {
  transform: scale(0.8);

  position: relative;
  bottom: 20px;
}
.pdf__white-bg div ul li .noslices {
  background: white;
}
.pdf__white-bg div ul li ul li .slice-contents--grey {
  background: #70707040;
}

.pdf__header__different__text div p {
  display: none;
}
.pdf__header__different__text {
  margin-bottom: 20px;
}
.detailed__result-li {
  margin-bottom: 1px;
}
.detailed__result__align-left {
  text-align: left;
  width: 150px;
  font-size: 13px;
  margin-left: 20px;
}
.detailed__result__align-right {
  text-align: right;
  width: 150px;
  font-size: 13px;

  margin-right: 20px;
}
.detailed__result__val {
  width: 20px;
  height: 10px;
  border-radius: 5px;
  margin: 0 1px;
}
.detailed__result__vals {
  position: relative;
  top: 5px;
}
.app {
  padding: 0 25px;
}

.leading-snug {
  font-size: 16px;
}
.heading {
  font-size: 40px;
}

.steps {
  display: flex;
  justify-content: space-between;
  position: relative;
  bottom: 50px;
}

.steps__item {
  background: #707070;
  width: 4px;
  height: 24px;
  border-radius: 4px;
  cursor: pointer;
  margin: 0;
  position: relative;
}
.step__text {
  font-size: 16px;
}
.step__picture {
  margin-bottom: 20px;
  position: relative;
  bottom: 30px;
}
.step__picture--small {
  width: 80px;
  height: 80px;
}
@media (max-width: 1279.89px) {
  .step__picture {
    left: 20px;
  }
}
.next__step {
  background: #87be2d;
  color: #2f373c;
  font-weight: 700;
}
.next__step--disabled {
  cursor: not-allowed;
  background: #707070;
  color: #2f373c;
  font-weight: 700;
}
.back__step {
  background: #707070;
  color: #2f373c;
  font-weight: 700;
}
.steps__item::after {
  content: "";
  width: 100%;
  height: 100%;
  border-radius: 4px;
  display: block;
  position: absolute;
  bottom: 0;
  transition: 0.2s ease-in-out;
}

.slider-horizontal {
  height: 0;
  bottom: -20px;
}

.slider-horizontal .slider-handle {
  background: #87be2d;
  width: 30px;
  height: 30px;
  top: -65px;
  right: -17px;
  box-shadow: none;
}
.leading-peace {
  font-size: 24px;
}
.extend {
  animation: shockwaveJump 1s ease-out infinite;
  z-index: 100;
}
.extend:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  border-radius: 50%;
  animation: shockwave 1s 0.65s ease-out infinite;
}
.extend:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  border-radius: 50%;
  animation: shockwave 1s 0.5s ease-out infinite;
}
@keyframes shockwave {
  0% {
    transform: scale(1);
    box-shadow: 0 0 4px #87be2d40, inset 0 0 1px #87be2d40;
  }
  95% {
    box-shadow: 0 0 50px rgba(0, 0, 0, 0), inset 0 0 30px rgba(0, 0, 0, 0);
  }
  100% {
    transform: scale(2.25);
  }
}
@keyframes shockwaveJump {
  0% {
    transform: scale(1);
  }
  40% {
    transform: scale(1.2);
  }
  50% {
    transform: scale(0.95);
  }
  55% {
    transform: scale(1.07);
  }
  60% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}
/* .extend {
  animation-name: extending;

  animation-timing-function: ease-in;
}
@keyframes extending {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
} */
.steps__item--current::after {
  height: calc(100% + 48px);
  background: inherit;
}
.steps__item--current--1::after {
  height: calc(100% + 24px);
  background: inherit;
}
.steps__item--current--2::after {
  height: calc(100% + 12px);
  background: inherit;
}
.steps__item--current--3::after {
  height: calc(100% + 6px);
  background: inherit;
}
.steps__item--current--4::after {
  height: calc(100% + 3px);
  background: inherit;
}
.steps__item--active::after {
  background: #87be2d;
}

.slider-tooltip {
  display: none;
}

.result__chart__container {
  position: relative;
  display: flex;
  height: 600px;
  padding: 0;
  margin: 0;
  transform: scale(0.9);
}

@media (max-width: 800px) {
  .result__chart__container__mobile {
    position: relative;
    right: 10%;
    display: flex;
    height: 600px;
    width: 100%;
    padding: 0;
    margin: 0;
    transform: scale(0.6);
  }
  /* .container__mobile {
    width: 100vw !important;
    margin: 0;
  } */

  /* .pdf__button {
    position: relative;
    left: 40%;
  } */
}

.result__chart {
  display: flex;
  width: 600px;
  margin: 0;
  padding: 0;
  position: relative;
}
.result__chart__pie {
  display: block;
}
.result__chart__pie__layer {
  position: relative;
  top: 300px;
  left: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotate(150deg);
}
.again__button {
  background: #707070;
  color: #2f373c;
  font-weight: 700;
}
.pdf__button {
  background: #87be2d;
  color: #2f373c;
  font-weight: 700;
}
.chart__legend {
  position: absolute;
  color: #707070;
}
@media (max-width: 800px) {
  .chart__legend__mobile {
    right: 10%;
  }
}

.chart__legend--3 {
  top: 120px;
  left: -20px;
}
.chart__legend--4 {
  left: 190px;
}
.chart__legend--1 {
  top: 575px;
  left: 200px;
}
.chart__legend--2 {
  left: 522px;
  top: 120px;
}
.chart__legend--5 {
  left: 522px;
  top: 440px;
}
.chart__legend--6 {
  left: -70px;
  top: 440px;
}
.chart__svg {
  position: absolute;
  top: 240px;
  left: 230px;
  z-index: 30;
  height: 120px;
  /* animation-name: imageAppear;
  animation-duration: 2s;
  animation-timing-function: ease-in; */
}
.pie {
  overflow: hidden;
  position: absolute;
  margin: 5em;
  padding: 0;
  border-radius: 50%;
  list-style: none;
}

.pie--1 {
  width: 33em;
  height: 33em;
  z-index: 1;
}

.pie--2 {
  width: 32em;
  height: 32em;
  z-index: 2;
  /* animation-name: imageAppear;
  animation-duration: 2s;
  animation-timing-function: ease-in; */
}

.pie--3 {
  width: 31.5em;
  height: 31.5em;
  z-index: 3;
}

.pie--4 {
  width: 30.5em;
  height: 30.5em;
  z-index: 4;
  /* animation-name: imageAppear;
  animation-duration: 2s;
  animation-timing-function: ease-in; */
}

.pie--5 {
  width: 30em;
  height: 30em;
  z-index: 5;
}

.pie--6 {
  width: 29em;
  height: 29em;
  z-index: 6;
  /* animation-name: imageAppear;
  animation-duration: 2s;
  animation-timing-function: ease-in; */
}

.pie--7 {
  width: 28.5em;
  height: 28.5em;
  z-index: 7;
}

.pie--8 {
  width: 27.5em;
  height: 27.5em;
  z-index: 8;
  /* animation-name: imageAppear;
  animation-duration: 2s;
  animation-timing-function: ease-in; */
}

.pie--9 {
  width: 27em;
  height: 27em;
  z-index: 9;
}

.pie--10 {
  width: 26em;
  height: 26em;
  z-index: 10;
  /* animation-name: imageAppear;
  animation-duration: 2s;
  animation-timing-function: ease-in; */
}

.pie--11 {
  width: 25.5em;
  height: 25.5em;
  z-index: 11;
}

.pie--12 {
  width: 24.5em;
  height: 24.5em;
  z-index: 12;
  /* animation-name: imageAppear;
  animation-duration: 2s;
  animation-timing-function: ease-in; */
}

.pie--13 {
  width: 24em;
  height: 24em;
  z-index: 13;
}

.pie--14 {
  width: 23em;
  height: 23em;
  z-index: 14;
  /* animation-name: imageAppear;
  animation-duration: 2s;
  animation-timing-function: ease-in; */
}

.pie--15 {
  width: 22.5em;
  height: 22.5em;
  z-index: 15;
}

.pie--16 {
  width: 21.5em;
  height: 21.5em;
  z-index: 16;
  /* animation-name: imageAppear;
  animation-duration: 2s;
  animation-timing-function: ease-in; */
}

.pie--17 {
  width: 21em;
  height: 21em;
  z-index: 17;
}

.pie--18 {
  width: 20em;
  height: 20em;
  z-index: 18;
  /* animation-name: imageAppear;
  animation-duration: 2s;
  animation-timing-function: ease-in; */
}

.pie--19 {
  width: 19.5em;
  height: 19.5em;
  z-index: 19;
}

.pie--20 {
  width: 18.5em;
  height: 18.5em;
  z-index: 20;
  /* animation-name: imageAppear;
  animation-duration: 2s;
  animation-timing-function: ease-in; */
}
.pie--21 {
  width: 18em;
  height: 18em;
  z-index: 21;
}

.pie--22 {
  width: 17em;
  height: 17em;
  z-index: 22;
  /* animation-name: imageAppear;
  animation-duration: 2s;
  animation-timing-function: ease-in; */
}
.pie--23 {
  width: 16.5em;
  height: 16.5em;
  z-index: 23;
}

.pie--24 {
  width: 15.5em;
  height: 15.5em;
  z-index: 24;
  /* animation-name: imageAppear;
  animation-duration: 2s;
  animation-timing-function: ease-in; */
}
.pie--25 {
  width: 15em;
  height: 15em;
  z-index: 25;
}

.pie--26 {
  width: 14em;
  height: 14em;
  z-index: 26;
  /* animation-name: imageAppear;
  animation-duration: 2s;
  animation-timing-function: ease-in; */
}
.pie--27 {
  width: 13.5em;
  height: 13.5em;
  z-index: 27;
}

.pie--28 {
  width: 12.5em;
  height: 12.5em;
  z-index: 28;
  /* animation-name: imageAppear;
  animation-duration: 2s;
  animation-timing-function: ease-in; */
}
.pie--29 {
  width: 12em;
  height: 12em;
  z-index: 29;
}

.pie--30 {
  width: 11em;
  height: 11em;
  z-index: 30;
  /* animation-name: imageAppear;
  animation-duration: 2s;
  animation-timing-function: ease-in; */
}
.pie--31 {
  width: 10.5em;
  height: 10.5em;
  z-index: 31;
}

.pie--32 {
  width: 9.5em;
  height: 9.5em;
  z-index: 32;
  /* animation-name: imageAppear;
  animation-duration: 2s;
  animation-timing-function: ease-in; */
}
.pie--33 {
  width: 9em;
  height: 9em;
  z-index: 33;
}

.pie--34 {
  width: 8em;
  height: 8em;
  z-index: 34;
  /* animation-name: imageAppear;
  animation-duration: 2s;
  animation-timing-function: ease-in; */
}
.pie--35 {
  width: 7.5em;
  height: 7.5em;
  z-index: 35;
}

.pie--36 {
  width: 6.5em;
  height: 6.5em;
  z-index: 36;
  /* animation-name: imageAppear;
  animation-duration: 2s;
  animation-timing-function: ease-in; */
}
.pie--37 {
  width: 6em;
  height: 6em;
  z-index: 37;
}

.pie--38 {
  width: 5em;
  height: 5em;
  z-index: 38;
  /* animation-name: imageAppear;
  animation-duration: 2s;
  animation-timing-function: ease-in; */
}
.pie--39 {
  width: 4.5em;
  height: 4.5em;
  z-index: 39;
}

.pie--40 {
  width: 3.5em;
  height: 3.5em;
  z-index: 40;
}
.slice {
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 50%;

  transform-origin: 0% 100%;
}
.slice:first-child {
  transform: rotate(0deg) skewY(-82.5deg);
}
.slice:nth-child(2) {
  transform: rotate(7.5deg) skewY(-82.5deg);
}
.slice:nth-child(3) {
  transform: rotate(15deg) skewY(-82.5deg);
}
.slice:nth-child(4) {
  transform: rotate(22.5deg) skewY(-82.5deg);
}
.slice:nth-child(5) {
  transform: rotate(30deg) skewY(-82.5deg);
}
.slice:nth-child(6) {
  transform: rotate(37.5deg) skewY(-82.5deg);
}
.slice:nth-child(7) {
  transform: rotate(45deg) skewY(-82.5deg);
}
.slice:nth-child(8) {
  transform: rotate(52.5deg) skewY(-82.5deg);
}
.slice:nth-child(9) {
  transform: rotate(60deg) skewY(-82.5deg);
}
.slice:nth-child(10) {
  transform: rotate(67.5deg) skewY(-82.5deg);
}
.slice:nth-child(11) {
  transform: rotate(75deg) skewY(-82.5deg);
}
.slice:nth-child(12) {
  transform: rotate(82.5deg) skewY(-82.5deg);
}
.slice:nth-child(13) {
  transform: rotate(90deg) skewY(-82.5deg);
}

.slice:nth-child(14) {
  transform: rotate(97.5deg) skewY(-82.5deg);
}

.slice:nth-child(15) {
  transform: rotate(105deg) skewY(-82.5deg);
}

.slice:nth-child(16) {
  transform: rotate(112.5deg) skewY(-82.5deg);
}

.slice:nth-child(17) {
  transform: rotate(120deg) skewY(-82.5deg);
}

.slice:nth-child(18) {
  transform: rotate(127.5deg) skewY(-82.5deg);
}

.slice:nth-child(19) {
  transform: rotate(135deg) skewY(-82.5deg);
}

.slice:nth-child(20) {
  transform: rotate(142.5deg) skewY(-82.5deg);
}

.slice:nth-child(21) {
  transform: rotate(150deg) skewY(-82.5deg);
}

.slice:nth-child(22) {
  transform: rotate(157.5deg) skewY(-82.5deg);
}

.slice:nth-child(23) {
  transform: rotate(165deg) skewY(-82.5deg);
}

.slice:nth-child(24) {
  transform: rotate(172.5deg) skewY(-82.5deg);
}

.slice:nth-child(25) {
  transform: rotate(180deg) skewY(-82.5deg);
}

.slice:nth-child(26) {
  transform: rotate(187.5deg) skewY(-82.5deg);
}

.slice:nth-child(27) {
  transform: rotate(195deg) skewY(-82.5deg);
}

.slice:nth-child(28) {
  transform: rotate(202.5deg) skewY(-82.5deg);
}

.slice:nth-child(29) {
  transform: rotate(210deg) skewY(-82.5deg);
}

.slice:nth-child(30) {
  transform: rotate(217.5deg) skewY(-82.5deg);
}

.slice:nth-child(31) {
  transform: rotate(225deg) skewY(-82.5deg);
}

.slice:nth-child(32) {
  transform: rotate(232.5deg) skewY(-82.5deg);
}

.slice:nth-child(33) {
  transform: rotate(240deg) skewY(-82.5deg);
}

.slice:nth-child(34) {
  transform: rotate(247.5deg) skewY(-82.5deg);
}

.slice:nth-child(35) {
  transform: rotate(255deg) skewY(-82.5deg);
}

.slice:nth-child(36) {
  transform: rotate(262.5deg) skewY(-82.5deg);
}

.slice:nth-child(37) {
  transform: rotate(270deg) skewY(-82.5deg);
}

.slice:nth-child(38) {
  transform: rotate(277.5deg) skewY(-82.5deg);
}

.slice:nth-child(39) {
  transform: rotate(285deg) skewY(-82.5deg);
}

.slice:nth-child(40) {
  transform: rotate(292.5deg) skewY(-82.5deg);
}

.slice:nth-child(41) {
  transform: rotate(300deg) skewY(-82.5deg);
}

.slice:nth-child(42) {
  transform: rotate(307.5deg) skewY(-82.5deg);
}

.slice:nth-child(43) {
  transform: rotate(315deg) skewY(-82.5deg);
}

.slice:nth-child(44) {
  transform: rotate(322.5deg) skewY(-82.5deg);
}

.slice:nth-child(45) {
  transform: rotate(330deg) skewY(-82.5deg);
}

.slice:nth-child(46) {
  transform: rotate(337.5deg) skewY(-82.5deg);
}

.slice:nth-child(47) {
  transform: rotate(345deg) skewY(-82.5deg);
}

.slice:nth-child(48) {
  transform: rotate(352.5deg) skewY(-82.5deg);
}

.slice-contents {
  position: absolute;
  left: -100%;
  width: 200%;
  height: 200%;
  border-radius: 50%;
  background: black;
}

.noslices .slice {
  display: none;
}
.noslices {
  background: #2f373c;
}

.slice-contents--orange {
  background: #f5a500;
}
.slice-contents--green {
  background-color: #87be2d;
}
.slice-contents--cyan {
  background: #2db4aa;
}
.slice-contents--grey {
  background: #707070;
}

@keyframes imageAppear {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes greenBG {
  from {
    background-color: #707070;
  }
  to {
    background-color: #87be2d;
  }
}
.lds-roller {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}
.lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #87be2d;
  margin: -4px 0 0 -4px;
}
.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}
.lds-roller div:nth-child(1):after {
  top: 63px;
  left: 63px;
}
.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}
.lds-roller div:nth-child(2):after {
  top: 68px;
  left: 56px;
}
.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}
.lds-roller div:nth-child(3):after {
  top: 71px;
  left: 48px;
}
.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}
.lds-roller div:nth-child(4):after {
  top: 72px;
  left: 40px;
}
.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}
.lds-roller div:nth-child(5):after {
  top: 71px;
  left: 32px;
}
.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}
.lds-roller div:nth-child(6):after {
  top: 68px;
  left: 24px;
}
.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}
.lds-roller div:nth-child(7):after {
  top: 63px;
  left: 17px;
}
.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}
.lds-roller div:nth-child(8):after {
  top: 56px;
  left: 12px;
}
@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  opacity: 0.8;
  background-color: #2f373c;
  z-index: 9000;
}
.loader div {
  transform: scale(3);
}

.scale--1 {
  transform: scale(1.5);
}

.scale--2 {
  transform: scale(1.47);
}

.scale--3 {
  transform: scale(1.44);
}

.scale--4 {
  transform: scale(1.41);
}

.scale--5 {
  transform: scale(1.38);
}

.scale--6 {
  transform: scale(1.35);
}

.scale--7 {
  transform: scale(1.32);
}

.scale--8 {
  transform: scale(1.29);
}

.scale--9 {
  transform: scale(1.26);
}

.scale--10 {
  transform: scale(1.23);
}

.scale--11 {
  transform: scale(1.2);
}

.scale--12 {
  transform: scale(1.17);
}

.scale--13 {
  transform: scale(1.1400000000000001);
}

.scale--14 {
  transform: scale(1.1099999999999999);
}

.scale--15 {
  transform: scale(1.08);
}

.scale--16 {
  transform: scale(1.05);
}

.scale--17 {
  transform: scale(1.02);
}

.scale--18 {
  transform: scale(0.99);
}

.scale--19 {
  transform: scale(0.96);
}

.scale--20 {
  transform: scale(0.93);
}

.scale--21 {
  transform: scale(0.9);
}

.scale--22 {
  transform: scale(0.87);
}

.scale--23 {
  transform: scale(0.84);
}

.scale--24 {
  transform: scale(0.81);
}

.scale--25 {
  transform: scale(0.78);
}

.scale--26 {
  transform: scale(0.75);
}

.scale--27 {
  transform: scale(0.72);
}

.scale--28 {
  transform: scale(0.69);
}

.scale--29 {
  transform: scale(0.66);
}

.scale--30 {
  transform: scale(0.63);
}

.scale--31 {
  transform: scale(0.6);
}

.scale--32 {
  transform: scale(0.57);
}

.scale--33 {
  transform: scale(0.54);
}

.scale--34 {
  transform: scale(0.51);
}

.scale--35 {
  transform: scale(0.48);
}

.scale--36 {
  transform: scale(0.44999999999999996);
}

.scale--37 {
  transform: scale(0.41999999999999993);
}

.scale--38 {
  transform: scale(0.3899999999999999);
}

.scale--39 {
  transform: scale(0.3600000000000001);
}

.scale--40 {
  transform: scale(0.33000000000000007);
}

.scale--41 {
  transform: scale(0.30000000000000004);
}
</style>

